<script>
  import { link } from "svelte-routing";
  import { panelController } from "../../../../stores/service";
  import { analyticsFilters } from "../../../../stores/analyticsFilters";
  import PanelEstandar from "../panels/panelEstandar.svelte";
  import FiltrosSidebar from "../panels/FiltrosSidebar.svelte";

  document.title = "Ratingg | Estadísticas";

  let activeTab = 0;
  let filtersOpen = false;

  $: dashboards = $panelController.service.listRatinggs;
  $: if (activeTab >= dashboards.length) activeTab = 0;

  const fmt = (iso) => {
    const [y, m, d] = iso.split("-");
    return `${d}/${m}/${y}`;
  };
</script>

<svelte:head>
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="anonymous" />
  <link
    href="https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,600;9..144,700&family=DM+Sans:wght@400;500;600;700&display=swap"
    rel="stylesheet"
  />
</svelte:head>

<div class="stats">
  <div class="stats-main">
    <div class="stats-bar">
      <div class="tabs" role="tablist" aria-label="Dashboards">
        {#each dashboards as d, i}
          <button
            type="button"
            role="tab"
            class="tab"
            class:is-active={activeTab === i}
            aria-selected={activeTab === i}
            on:click={() => (activeTab = i)}
            title={d.config.name}>{d.config.name}</button
          >
        {/each}
      </div>

      <div class="bar-actions">
        <a
          use:link
          href="/MainAnalytics/configurar?d={activeTab}"
          class="bar-btn">Configurar</a
        >
        <button
          type="button"
          class="bar-btn filters-toggle"
          on:click={() => (filtersOpen = true)}
        >
          Filtros
        </button>
      </div>
    </div>

    <p class="range">
      Periodo: {fmt($analyticsFilters.f1)} – {fmt($analyticsFilters.f2)}
    </p>

    {#each dashboards as data, inx}
      <div class="panel-slot" hidden={activeTab !== inx}>
        <PanelEstandar
          data={{
            name: data.config.name,
            datalist: {
              idfirebase: data.hasOwnProperty("analytics")
                ? data.analytics.idDoc
                : "",
            },
            listindex: inx,
          }}
        />
      </div>
    {/each}
  </div>

  <div class="stats-side">
    <FiltrosSidebar
      open={filtersOpen}
      on:close={() => (filtersOpen = false)}
      on:applied={() => (filtersOpen = false)}
    />
  </div>

  {#if filtersOpen}
    <button
      type="button"
      class="scrim"
      aria-label="Cerrar filtros"
      on:click={() => (filtersOpen = false)}
    />
  {/if}
</div>

<style>
  .stats {
    --cream: #fbf6ea;
    --cream-deep: #f3ead5;
    --ink: #2a2a1c;
    --ink-soft: #57543f;
    --ink-faint: #83805f;
    --olive-900: #2c3320;
    --olive-600: #647a3f;
    --olive-300: #a7be78;
    --olive-200: #cbdaa4;
    --olive-100: #e4ebce;
    --yellow-500: #eec13b;
    --yellow-100: #fbeec4;
    --coral-600: #ce5b34;
    --coral-500: #e2703f;
    --coral-100: #f8d9c6;
    --shadow-soft: 0 1px 2px rgba(42, 42, 28, 0.06),
      0 12px 28px -12px rgba(42, 42, 28, 0.18);
    font-family: "DM Sans", ui-sans-serif, system-ui, sans-serif;
    color: var(--ink);
    display: grid;
    grid-template-columns: minmax(0, 1fr) 260px;
    gap: 1rem;
    align-items: start;
  }

  .stats-side {
    position: sticky;
    top: 0.75rem;
  }

  .stats-bar {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    justify-content: space-between;
  }

  .tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    padding: 3px;
    background: #e4ebce;
    border-radius: 10px;
    min-width: 0;
  }

  .tab {
    border: 0;
    text-align: left;
    background: transparent;
    border-radius: 8px;
    padding: 0.4rem 0.9rem;
    font-size: 0.85rem;
    font-weight: 600;
    color: #83805f;
  }

  .tab.is-active {
    background: #fbf6ea;
    color: #2c3320;
    box-shadow: 0 1px 3px rgba(44, 51, 32, 0.15);
  }

  .bar-actions {
    display: flex;
    gap: 0.4rem;
    flex: none;
  }

  .bar-btn {
    display: inline-flex;
    align-items: center;
    border: 1px solid rgba(44, 51, 32, 0.22);
    background: transparent;
    color: var(--olive-900);
    border-radius: 999px;
    padding: 0.35rem 0.9rem;
    font-size: 0.82rem;
    font-weight: 600;
    text-decoration: none;
  }

  .bar-btn:hover {
    background: var(--olive-100);
    color: var(--olive-900);
  }

  .bar-btn:focus-visible {
    outline: 2px solid var(--coral-600);
    outline-offset: 2px;
  }

  .filters-toggle {
    display: none;
  }

  .range {
    margin: 0.5rem 0 0.75rem;
    font-size: 0.78rem;
    color: #83805f;
  }

  .scrim {
    position: fixed;
    inset: 0;
    z-index: 1040;
    border: 0;
    background: rgba(44, 51, 32, 0.35);
  }

  @media (max-width: 991px) {
    .stats-bar {
      flex-wrap: wrap;
    }

    .tabs {
      flex: 1 1 100%;
    }

    .tab {
      flex: 1 1 auto;
    }

    .bar-actions {
      margin-left: auto;
    }

    .stats {
      grid-template-columns: minmax(0, 1fr);
    }

    .stats-side {
      position: static;
    }

    .filters-toggle {
      display: inline-block;
    }
  }
</style>
